import { Directive } from "@angular/core";
import { NG_VALIDATORS, Validator, Validators } from "@angular/forms";
    import { AbstractControl, ValidationErrors } from '@angular/forms';
    
    @Directive({
    selector: '[emailValidator]',
    providers: [
        { provide: NG_VALIDATORS, useValue: TCMEmailValidator, multi: true }
    ],
    standalone: false
})
    export class TCMEmailValidator implements Validator {
        public validate(control: AbstractControl): ValidationErrors {
            if (control.value) {
                if (!new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g).test(control.value)) {
                    return { "emailformat": true };
                }
            }
            return null
        }
    
        public registerOnValidatorChange(fn: () => void): void {
        }
    }